export const AVAILABLE_ROLES = [
  "Pamunuan",
  "Diakono",
  "Diakonesa",
  "Mang-aawit",
  "Pananalapi",
  "Kalihim",
  "TSV",
  "SCAN",
  "PNK Kagawad"
];

export const AVAILABLE_CATEGORIES = [
  "Buklod",
  "Kadiwa",
  "Binhi"
];